<template>
    <v-container>
        <v-card class="pa-3 ma-3">
            <v-toolbar flat color="#1d2735" dark>
                <v-icon
                    class="white--text"
                    style="font-size: 35px; margin-right: 10px"
                    >mdi-clipboard-file-outline</v-icon
                >
                <pre><v-toolbar-title><h2>Archivos</h2></v-toolbar-title></pre>
            </v-toolbar>

            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        @click="isCreateFolderDialogVisible = true"
                        color="orange darken-1"
                        class="mt-2"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon class="white--text"
                            >mdi-folder-plus-outline</v-icon
                        >
                    </v-btn>
                </template>
                <span>Nueva carpeta</span>
            </v-tooltip>

            <loader :loading="isLoading"></loader>

            <v-card-text>
                <div class="d-flex flex-wrap gap-3">
                    <template v-for="file in folders">
                        <!-- Carpetas -->
                        <v-card
                            class="me-3 mb-3 pointer"
                            @click="openFilesFolderDialog(file)"
                        >
                            <v-card-text>
                                <div class="d-flex justify-end">
                                    <!-- .stop para evitar conflictos con el card click -->
                                    <v-icon
                                        class="pointer"
                                        @click.stop="
                                            openConfirmDialog(file.folder_name)
                                        "
                                        >mdi-trash-can-outline</v-icon
                                    >
                                </div>

                                <!-- Detiene la propagación del evento click -->
                                <v-text-field
                                    prepend-icon="mdi-folder-outline"
                                    v-model="file.folder_name"
                                    dense
                                    @click.stop
                                ></v-text-field>
                            </v-card-text>
                        </v-card>
                    </template>
                </div>
            </v-card-text>
        </v-card>

        <!-- Crear una carpeta de archivos de Fidias -->
        <v-dialog v-model="isCreateFolderDialogVisible" max-width="400px">
            <v-card>
                <v-card-title class="text-h5 dialog-title">
                    Ingresa el nombre de la carpeta
                </v-card-title>
                <v-card-text class="mt-3">
                    <v-form ref="form" v-model="formValid">
                        <v-text-field
                            v-model="folder_name"
                            label="Nombre de la carpeta"
                            outlined
                            dense
                            :rules="[rules.required]"
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                    <v-btn
                        color="error"
                        @click="isCreateFolderDialogVisible = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" @click="createFolder(folder_name)"
                        >Confirmar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Archivos por carpeta -->
        <v-dialog
            v-model="isFilesFolderDialogVisible"
            max-width="800px"
            scrollable
        >
            <v-card>
                <v-card-title class="text-h5 dialog-title">
                    {{ folder.folder_name }}
                </v-card-title>
                <v-card-text class="mt-3">
                    <v-row>
                        <v-col cols="12">
                            <v-file-input
                                multiple
                                outlined
                                dense
                                label="Archivos"
                                v-model="files"
                                @change="addFileToFolder(folder, files)"
                            ></v-file-input>
                        </v-col>
                        <v-col cols="12">
                            <v-data-table
                                :headers="headers"
                                hide-default-header
                                hide-default-footer
                                :items="folder.files"
                                :items-per-page="-1"
                            >
                                <template v-slot:item.file_name="{ item }">
                                    <a
                                        :href="
                                            item.id
                                                ? `storage/${item.file_url}`
                                                : '#'
                                        "
                                        :target="item.id ? '_blank' : '_self'"
                                        >{{ item.file_name }}</a
                                    >
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-icon
                                        @click="
                                            deleteFileInFolder(folder, item)
                                        "
                                        small
                                        class="mr-2"
                                        color="red"
                                        style="font-size: 25px"
                                        title="BORRAR"
                                        >mdi-trash-can</v-icon
                                    >
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                    <v-btn
                        color="error"
                        @click="isFilesFolderDialogVisible = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        color="success"
                        @click="confirmAddFiles(folder.folder_name)"
                        >Confirmar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Confirmar la eliminación de una carpeta -->
        <ConfirmDialog
            ref="confirmDialog"
            v-model="isConfirmDialogVisible"
            v-on:confirm="deleteFolder"
            titulo="Eliminar carpeta"
            texto="¿Está seguro que desea eliminar esta carpeta? Eliminará también los archivos que se encuentren en ella"
            :data="null"
        />
    </v-container>
</template>

<script>
import ConfirmDialog from "../../../global_components/VConfirmDialog.vue";
import { rules } from "../../../utils/rules";
import loader from "../../../base_components/base/Loader.vue";

export default {
    name: "Archivos",
    components: { ConfirmDialog, loader },
    data() {
        return {
            folders: [],
            folder: {
                folder_name: "",
                files: [],
            },
            headers: [
                { text: "Nombre", value: "file_name" },
                { text: "Acciones", value: "actions" },
            ],
            files: [],
            isFilesFolderDialogVisible: false,
            isConfirmDialogVisible: false,
            isCreateFolderDialogVisible: false,
            folder_name: "",
            formValid: false,
            rules: rules,
            isLoading: false,
        };
    },
    mounted() {
        this.getArchivosFidias();
    },
    methods: {
        // Traer las carpetas de archivos de Fidias
        getArchivosFidias() {
            this.isLoading = true;
            axios.get("api/archivos/fidias").then((response) => {
                this.folders = response.data;
                this.isLoading = false;
            });
        },
        // Crear una carpeta de archivos de Fidias
        async createFolder(name) {
            try {
                this.$refs.form.validate();
                if (!this.formValid) return;

                this.isLoading = true;

                const res = await axios.post("api/archivo/folder", {
                    name: name,
                });
                const folder = {
                    folder_name: name,
                    files: [],
                };

                this.folders.push(folder);
                this.isLoading = false;
                this.$toast.sucs(res.data.message);
                this.isCreateFolderDialogVisible = false;
            } catch (error) {
                this.$toast.error(error.response.data.message);
                this.isLoading = false;
            }
        },
        // Abrir el dialogo de confirmación para eliminar una carpeta
        openConfirmDialog(name) {
            this.folder_name = name;
            this.isConfirmDialogVisible = true;
        },
        // Eliminar una carpeta de archivos de Fidias
        async deleteFolder() {
            await this.deleteFolderFromDatabase(this.folder_name);

            const index = this.folders.findIndex(
                (element) => element.folder_name == this.folder_name
            );
            if (index !== -1) {
                this.folders.splice(index, 1);
            }
        },
        async deleteFolderFromDatabase(folder_name) {
            try {
                this.isLoading = true;
                const res = await axios.delete(
                    `api/archivo/folder/${folder_name}`
                );
                this.isLoading = false;
                this.$toast.sucs(res.data.message);
            } catch (error) {
                this.$toast.error(error.response.data.message);
                this.isLoading = false;
            }
        },

        // Abrir el dialogo de archivos de una carpeta
        openFilesFolderDialog(folder) {
            this.folder = folder;
            this.isFilesFolderDialogVisible = true;
        },
        // Agregar archivos a una carpeta
        addFileToFolder(folder, fileList) {
            if (!fileList.length) return;
            for (const file of fileList) {
                folder.files.push({
                    id: null,
                    file_name: file.name,
                    file_path: null,
                    file: file,
                    created_at: moment().format("YYYY-M-DD H:m:ss"),
                });
            }
            this.files = [];
        },
        // Confirmar la adición de archivos a una carpeta
        confirmAddFiles(folder_name) {
            this.isLoading = true;
            const formData = new FormData();

            this.folder.files.forEach((fileObj) => {
                if (fileObj.file) {
                    // Solo enviamos los archivos nuevos que tienen el objeto File
                    formData.append("files[]", fileObj.file);
                }
            });

            axios
                .post(`api/archivo/folder/${folder_name}`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    this.$toast.sucs(res.data.message);
                    this.isFilesFolderDialogVisible = false;
                    this.getArchivosFidias();
                    this.isLoading = false;
                });
        },
        // Eliminar un archivo de una carpeta
        async deleteFileInFolder(folder, file) {
            try {
                this.isLoading = true;
                await this.deleteFileFromDatabase(file);
                const index = folder.files.findIndex(
                    (element) => element == file
                );
                folder.files.splice(index, 1);
            } catch (error) {
                this.$toast.error(
                    error.response?.data?.message ||
                        "Error al eliminar el archivo"
                );
            } finally {
                this.isLoading = false; // Aseguramos que el loader se desactive
            }
        },
        // Eliminar un archivo de la base de datos
        async deleteFileFromDatabase(item) {
            try {
                const res = await axios.delete(`api/archivo/file/${item.id}`);
                this.$toast.sucs(res.data.message);
                // this.deleteFromList(item);
            } catch (error) {
                this.$toast.error(error.response.data.message);
                this.isLoading = false;
            }
        },
    },
    computed: {},
    watch: {},
};
</script>
